import { render, staticRenderFns } from "./ShareImage.vue?vue&type=template&id=c80c3edc&scoped=true"
import script from "./ShareImage.vue?vue&type=script&lang=js"
export * from "./ShareImage.vue?vue&type=script&lang=js"
import style0 from "./ShareImage.scss?vue&type=style&index=0&id=c80c3edc&prod&scoped=true&lang=scss&external"
import style1 from "./ShareImage_gt.scss?vue&type=style&index=1&id=c80c3edc&prod&scoped=true&lang=scss&external"
import style2 from "./ShareImage_pc.scss?vue&type=style&index=2&id=c80c3edc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80c3edc",
  null
  
)

export default component.exports